// extracted by mini-css-extract-plugin
export default {"container":"yandexHotelMap-module__container__-d6gn","emptyMapContainer":"yandexHotelMap-module__emptyMapContainer__q5xpt"};